import React from 'react';
import { Link } from "react-router-dom";
import { motion } from 'framer-motion';

const pageVariants = {
    initial: {
        opacity: 0,
    },
    in: {
        opacity: 1,
    },
    out: {
        opacity: 0,
    },
};

const pageTransition = {
    type: 'tween',
    ease: 'easeInOut',
    delay: 1,
};

const Welcome = () => {
    return (
        <>
            <motion.div
                initial="initial"
                animate="in"
                exit="out"
                variants={pageVariants}
                transition={pageTransition}
            >
                <div className="ContentWrap">
                    <div className="ContentMain">
                        <h1>
                            <img src="./images/halloween.png" className="HalloweenTop" alt="Halloween" />
                        </h1>
                        <div className="Button">
                            <Link to={`/trickortreat/`}>Tap</Link>
                        </div>
                    </div>
                </div>
            </motion.div>
        </>
    );
};

export default Welcome;